import {createAction} from 'util/redux'

const NAMESPACE = 'SOLL_IST/'
export const sollIstRequestRefreshAction = createAction<{ persNr: number, date: number }>(NAMESPACE + 'RequestRefresh')